const PATH =
  'fe.components.measure.view.cycles.cycle_scores_form.dimension_score_input';

const messages = {
  low: {
    key: `${PATH}.low`,
    defaultValue: 'Low'
  },
  mid: {
    key: `${PATH}.mid`,
    defaultValue: 'Mid'
  },
  high: {
    key: `${PATH}.high`,
    defaultValue: 'High'
  }
};

export default messages;
